export function isAlpha(ch) {
    return ("a" <= ch && ch <= "z") || ("A" <= ch && ch <= "Z");
}
export function isExtendedAlpha(ch) {
    return isAlpha(ch) || "@_$".includes(ch);
}
export function isUint(literal) {
    return (literal.length > 0 &&
        "123456789".includes(literal[0]) &&
        [...literal].every(ch => "0123456789".includes(ch)));
}
//# sourceMappingURL=utils.js.map